/**
 * Color palette for comparison charts (max 3 entities)
 */

export interface ComparisonColor {
  primary: string;
  gradient: string[]; // 4 hex colors for heatmap intensity (light to dark)
}

export const COMPARISON_COLORS: ComparisonColor[] = [
  {
    // Entity 1: Green (existing brand color)
    primary: "#00c889",
    gradient: ["#bbf7d0", "#86efac", "#22c55e", "#16a34a"], // green-200 to green-600
  },
  {
    // Entity 2: Blue
    primary: "#3b82f6",
    gradient: ["#bfdbfe", "#93c5fd", "#3b82f6", "#2563eb"], // blue-200 to blue-600
  },
  {
    // Entity 3: Orange/Amber
    primary: "#f59e0b",
    gradient: ["#fde68a", "#fcd34d", "#f59e0b", "#d97706"], // amber-200 to amber-600
  },
];

/**
 * Get color for an entity by its index
 */
export const getEntityColor = (index: number): ComparisonColor => {
  return COMPARISON_COLORS[index % COMPARISON_COLORS.length];
};
